import counterReducer from "./features/counterSlice"
import userReducer from "./features/userSlice"
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers, configureStore } from "@reduxjs/toolkit";


const persistConfig = {
    key: 'root',
    storage,
}

const rootReducer = combineReducers({
    counter: counterReducer,
    user: userReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer
});

export const persistor = persistStore(store);